export const osnTop105SIcon = {
  data: `<svg viewBox="0 0 280 213" fill="none" xmlns="http://www.w3.org/2000/svg"><path opacity="0.5" d="M43.72
178.36C59.68 195.72 83.2 206.36 115.68 206.36C160.76 206.36 190.44 181.44 190.44 141.96C190.44 104.16 162.16 81.76
130.52 81.76C113.44 81.76 98.32 88.48 88.52 97.16V50.4H177.84V16.24H49.6V122.92L77.32 130.48C88.52 119.84 101.12
115.08 116.52 115.08C137.8 115.08 150.12 126.56 150.12 143.64C150.12 159.04 137.52 171.64 115.4 171.64C95.8 171.64
78.44 164.64 65.56 151.48L43.72 178.36Z" fill="#0F0125" stroke="currentColor" stroke-width="13"/></svg>`,
  name: 'top-10-5-s',
};
